const isEmpty = function (str) {
    if (str === null || str === '' || str === undefined || `${str}`.trim() === '') {
        return true;
    }
    return false;
};

const isNumeric = function (value) {
    if (Number.isNaN(parseInt(value))) {
        return false;
    }
    return true;
};

export { isEmpty, isNumeric };
